module.exports = "/_next/static/images/12a-f9d16a237f022328cd1cd15adaf9caca.png";